type Props = {
  condition: boolean,
  children: any
}

const Render = ({ condition, children }: Props) => {

  if (condition) return children

  return null
}


export default Render